import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-8 px-3" data-id="element-52">
      <div className="max-w-4xl mx-auto text-center space-y-3" data-id="element-53">
        <p className="font-display text-lg text-accent font-semibold" data-id="element-54">
          SALUD EN TU PLATO™
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm" data-id="element-55">
          <a href="mailto:soporte@sistemaclinico.com" className="flex items-center gap-2 text-white/50 hover:text-accent transition-colors" data-id="element-56">
            <MailIcon className="w-4 h-4" data-id="element-57" />
            soporte@sistemaclinico.com
          </a>
          <a href="https://instagram.com/sistemaclinicopro" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/50 hover:text-accent transition-colors" data-id="element-58">
            <InstagramIcon className="w-4 h-4" data-id="element-59" />
            @sistemaclinicopro
          </a>
        </div>
        <p className="text-xs text-white/30" data-id="element-60">
          © Sistema Clínico Pro Elite™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}